import React from "react";
import { Button } from "semantic-ui-react";
import { ModalBuilder } from "@redriver/cinnamon";
import { getUserPermissions, updateUserPermissions } from "./actions";
import RoleForm from "../ListRoles/RoleForm";
import { TranslatedModal } from "features/../../../shared/components/modals";

const mapNode = (node) => {
  if (!node || node.length === 0) return [];

  const nodes = node.map((item) => ({
    value: item.boilerPlateTandCsId,
    text: item.boilerPlateTandCs,
    checked: item.selected,
    children: [],
  }));

  return [{ text: "T&Cs", value: "tandcs-root-node", defaultExpanded: true, children: nodes }];
};

const EditUserPermissions = ({ as: As = Button, user, onSubmitted, ...props }) => {
  return (
    <ModalBuilder
      withForm
      loadAction={getUserPermissions}
      loadParams={user.id}
      loadTransform={(data) => {
        const boilerPlateTerms = data.boilerPlateTerms || [];
        const selectedIds = boilerPlateTerms
          .filter((term) => term.selected)
          .map((term) => term.boilerPlateTandCsId);
      
        const nodes = mapNode(boilerPlateTerms);
      
        return {
          ...data,
          boilerPlateTerms: selectedIds,
          boilerPlateTermsNodes: nodes,
        };
      }}
      submitAction={updateUserPermissions}
      submitParams={{ userId: user.id }}
      onSubmitted={onSubmitted}
      renderTrigger={(showModal) => <As onClick={showModal} {...props} />}
      renderModal={(modalProps, formProps) => {
        return (
          <TranslatedModal.Edit {...modalProps} header="Edit User Permissions">
            <RoleForm
              formProps={formProps}
              id={user.id}
              editMode
              userMode={true}
              userAreaForUserBeingEdited={user.userArea}
              boilerPlateTermsNodes={formProps.value.boilerPlateTermsNodes}
            />
          </TranslatedModal.Edit>
        );
      }}
    />
  );
};

export default EditUserPermissions;